import { PenTool } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function SignNode({ id, data, selected }) {
  const summary = data.message ? `Sign: "${data.message.slice(0, 30)}..."` : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.wallet}
      icon={PenTool}
      label={data.label}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
